import * as Combobox from './Combobox'
import * as Dropdown from './Dropdown'
import * as Input from './Input'
import * as MultiSelectCombobox from './MultiSelectCombobox'

export const LocalsForms = {
  Combobox,
  Dropdown,
  Input,
  MultiSelectCombobox,
}
